import { ProtectedRoute as SharedProtectedRoute } from '@mdvip/shared/system/ProtectedRoute';
import type { ReactNode } from 'react';

import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  return (
    <SharedProtectedRoute isAuthenticated={isAuthenticated} isLoading={isLoading} portalType="providers">
      {children}
    </SharedProtectedRoute>
  );
}
